import styled from 'styled-components';
import Colors from '../../../../../config/Colors';

export const Container = styled.div`
    min-height: 300px;
    min-width: 380px;
    display: flex;
    flex-direction: column;
    font-family: NunitoSans-Bold;
    font-size: 1.8rem;
`;

export const Header = styled.header`
    padding: 24px;
    border-bottom: 1px solid ${Colors.border};
`;

export const HeaderTitle = styled.h1`
    font-family: NunitoSans-Bold;
    font-size: 1.8rem;
    align-self: flex-start;
    margin-bottom: 5px;
    opacity: 0.8;
`;

export const SelectContent = styled.div`
    display: flex;
    flex: 7;
    justify-content: space-between;
    align-items: center;
    padding: 0 25px 0 25px;
    position: relative;
`;

export const DropdownSection = styled(SelectContent)`
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

export const Separator = styled.span`
    position: absolute;
    top: 50%;
    left: 46.75%;
`;

export const DropdownTitle = styled.span`
    font-family: NunitoSans-Regular;
    font-size: 1.6rem;
    align-self: flex-start;
    margin-bottom: 5px;
    opacity: 0.8;
`;

export const Footer = styled.footer`
    border-top: 1px solid ${Colors.border};
    padding-right: 25px;
    display: flex;
    flex: 3;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
`;
